import request from '@/api/request'

export function addBossNowUserToBranch (data) {
  return request({
    url: '/user/bossnow/branch',
    method: 'post',
    data
  })
}

export function delBossNowUserToBranch (uid, bid) {
  return request({
    url: '/user/bossnow/' + uid + '/branch/' + bid,
    method: 'delete'
  })
}
